import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { ServerClass } from 'interfaces/class'
import { StudentClassesApi } from '@/components/routes/student/current/helpers/requests'
import { useUserStore } from '@/stores/user'

export const useStudentStore = defineStore('student', () => {
  const userStore = useUserStore()

  const group = computed(() => userStore.user?.groups?.[0])

  const classes = ref<ServerClass[]>([])

  async function fetchSchedule() {
    if (userStore.isStudent && group.value) {
      try {
        classes.value = (await StudentClassesApi.getWeekSchedule()).data
      } catch (e) {
        classes.value = []
      }
    }
  }

  const chiefClasses = computed(() => {
    if (userStore.isGroupLeader) {
      return classes.value
    } else {
      return classes.value.filter((c) => c.isGroupLeader)
    }
  })

  const isCurrentChief = computed(() => !!chiefClasses.value.length)

  return {
    classes,
    fetchSchedule,
    chiefClasses,
    isCurrentChief
  }
})
